// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'leeris_access_token',
  REFRESH_TOKEN: 'leeris_refresh_token',
  USER_DATA: 'leeris_user_data',
  LANGUAGE: 'leeris_language',
} as const;

// Routes
export const ROUTES = {
  HOME: '/',
  SPLASH: '/splash',
  LOGIN: '/login',
  OTP_LOGIN: '/login/otp',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  BENEFITS: '/benefits',
  CLAIMS: '/claims',
  CLAIM_CREATE: '/claims/create',
  CLAIM_DETAIL: '/claims/:id',
  CARD: '/card',
  PROVIDERS: '/providers',
  PROVIDER_DETAIL: '/providers/:id',
  NOTIFICATIONS: '/notifications',
  SUPPORT: '/support',
  SUPPORT_CREATE: '/support/create',
  SUPPORT_DETAIL: '/support/:id',
} as const;

// Currency
export const CURRENCY = {
  CODE: 'XOF',
  SYMBOL: 'FCFA',
} as const;

// Claim Type Labels (fr)
export const CLAIM_TYPE_LABELS: Record<string, string> = {
  consultation: 'Consultation',
  pharmacy: 'Pharmacie',
  hospital: 'Hospitalisation',
  dental: 'Soins dentaires',
  optical: 'Optique',
  specialist: 'Consultation spécialiste',
  lab: 'Analyses & biologie',
  other: 'Autre',
};

// Status Colors
export const STATUS_COLORS = {
  // Claim Status
  draft: 'gray',
  submitted: 'blue',
  under_review: 'yellow',
  additional_info_required: 'orange',
  approved: 'green',
  partially_approved: 'green',
  rejected: 'red',
  paid: 'green',
  
  // Ticket Status
  open: 'blue',
  in_progress: 'yellow',
  waiting_customer: 'orange',
  resolved: 'green',
  closed: 'gray',
} as const;

// Priority Colors
export const PRIORITY_COLORS = {
  low: 'gray',
  medium: 'blue',
  high: 'orange',
  urgent: 'red',
} as const;

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ACCEPTED_TYPES: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
  ACCEPTED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.pdf'],
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  ITEMS_PER_PAGE_OPTIONS: [10, 20, 50, 100],
} as const;

// OTP
export const OTP = {
  LENGTH: 6,
  EXPIRY_MINUTES: 5,
  RESEND_COOLDOWN_SECONDS: 60,
} as const;

// Support SLA
export const SUPPORT_SLA = {
  RESPONSE_TIME_HOURS: 48,
} as const;

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
  DISPLAY_TIME: 'dd/MM/yyyy HH:mm',
  API: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  INPUT: 'yyyy-MM-dd',
} as const;

// Validation
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PHONE_MIN_LENGTH: 10,
  NAME_MIN_LENGTH: 2,
  SUBJECT_MIN_LENGTH: 5,
  DESCRIPTION_MIN_LENGTH: 20,
} as const;

// Languages
export const LANGUAGES = [
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'English' },
] as const;

// Default Language
export const DEFAULT_LANGUAGE = 'fr';
